// src/components/ClientEditModal.jsx
// Uses ClientFormFull for comprehensive editing including all Medicare fields
import React from "react";
import { useTranslation } from "react-i18next";
import ClientFormFull from "./ClientFormFull";

export default function ClientEditModal({ open, client, onClose, onSave, saving }) {
  const { t } = useTranslation();

  if (!open) return null;

  // Transform client data to match ClientFormFull expected format
  const initialData = {
    ...client,
    // SOA/PTC fields need to be transformed
    soa: { onFile: client?.soaOnFile, signed: client?.soaSigned },
    ptc: { onFile: client?.ptcOnFile, signed: client?.ptcSigned },
    enrollment: { onFile: client?.enrollmentOnFile }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative w-full max-w-5xl bg-white rounded-2xl shadow-xl ring-1 ring-black/5 max-h-[90vh] overflow-hidden flex flex-col">
        <div className="h-2 bg-amber-400 rounded-t-2xl flex-shrink-0" />
        <div className="p-6 flex-shrink-0 border-b">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-slate-800">{t('editClientDetails')}</h2>
            <button type="button" onClick={onClose} className="text-slate-500 hover:text-slate-700 text-xl">
              &times;
            </button>
          </div>
        </div>
        <div className="p-6 overflow-y-auto flex-1">
          <ClientFormFull
            initial={initialData}
            saving={saving}
            onCancel={onClose}
            onSave={onSave}
            hideHealthData={true}
          />
        </div>
      </div>
    </div>
  );
}
